import { useMe } from './useMe';

/** Server switch for image generation and the Purchases section. Off until /me says otherwise (also off if /me fails). */
export function useImageFeatures(): { enabled: boolean; ready: boolean } {
  const { data, isLoading, isError } = useMe();
  return { enabled: data?.imageFeaturesEnabled === true, ready: !isLoading && (data !== undefined || isError) };
}
